"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
exports.default = vue_1.default.extend({
    props: ['cssClass'],
    mixins: [ConditionalDisplay_1.default],
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Layout/Row.vue
// module id = 204
// module chunks = 0